import styled from 'styled-components';

export const LinksListContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const LinksListItem = styled.li`
  margin: 12px 0;
`;
